import { RequestCommissionChangeCTA } from "@faire/help-center-self-serve/brand/instantAnswers/ctas";
import articlePage from "@faire/web-api/routes/support/articles/articleId";
export var requestCommissionUpdate = function requestCommissionUpdate(strictLocalize, articles) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getRequestCommission;
        return (_getRequestCommission = getRequestCommissionChangeCTA(context, strictLocalize)) === null || _getRequestCommission === void 0 ? void 0 : _getRequestCommission.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getRequestCommission2, _getRequestCommission3;
        return (_getRequestCommission2 = getRequestCommissionChangeCTA(context, strictLocalize)) === null || _getRequestCommission2 === void 0 ? void 0 : (_getRequestCommission3 = _getRequestCommission2.getLink) === null || _getRequestCommission3 === void 0 ? void 0 : _getRequestCommission3.call(_getRequestCommission2);
      }
    },
    learnMoreLink: articles !== null && articles !== void 0 && articles.FaireDirect.ORDER_COMMISSION ? articlePage(articles.FaireDirect.ORDER_COMMISSION.id) : undefined
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  var _context$brandOrder, _context$brandOrder$b;
  var brandOrderToken = (_context$brandOrder = _context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token;
  if (!brandOrderToken) {
    return {
      getTitle: function getTitle() {
        return strictLocalize({
          id: "LNjxMH",
          defaultMessage: "How to update commission to 0%"
        });
      },
      getDescription: function getDescription() {
        return [strictLocalize({
          id: "6NulTy",
          defaultMessage: "We’re happy to update an order to 0% commission when you provide documentation of your relationship with an eligible retailer. This documentation can be submitted by clicking “Request commission change” on the specific order page in your brand portal. Once submitted, our team will review your request and provide you with an update via email within 2 business days."
        })];
      }
    };
  }
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "fYRs9C",
        defaultMessage: "How to update commission on this order to 0%"
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "DNYfPe",
        defaultMessage: "We’re happy to update an order to 0% commission when you provide documentation of your relationship with an eligible retailer. This documentation can be submitted by clicking “Request commission change” on the specific order page in your brand portal or below. Once submitted, our team will review your request and provide you with an update via email within 2 business days."
      })];
    }
  };
};
var getRequestCommissionChangeCTA = function getRequestCommissionChangeCTA(context, strictLocalize) {
  var _context$brandOrder2, _context$brandOrder2$;
  var brandOrderToken = (_context$brandOrder2 = context.brandOrder) === null || _context$brandOrder2 === void 0 ? void 0 : (_context$brandOrder2$ = _context$brandOrder2.brand_order) === null || _context$brandOrder2$ === void 0 ? void 0 : _context$brandOrder2$.token;
  if (!brandOrderToken) {
    return undefined;
  }
  return RequestCommissionChangeCTA(brandOrderToken, strictLocalize);
};